"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file assets.proto (package assets, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteImageResponse = exports.DeleteImageRequest = exports.UploadImageResponse = exports.UploadImageRequest = exports.GetUploadedImagesResponse = exports.GetUploadedImagesRequest = exports.UploadedImage = exports.UploadPackResponse = exports.ModelConfig = exports.UploadPackRequest = exports.GetCategoryResponse = exports.GetCategoryRequest = exports.DeletePackResponse = exports.DeletePackRequest = exports.CreateCategoryResponse = exports.CreateCategoryRequest = exports.BuildPackResponse = exports.BuildPackRequest = exports.Model = exports.ModelPack = exports.ModelCategory = exports.Asset = exports.AssetInformation = exports.GetAssetResponse = exports.GetAssetRequest = exports.UploadAssetResponse = exports.UploadAssetRequest = exports.GetHashResponse = exports.GetHashRequest = exports.ListAssetsResponse = exports.ListAssetsRequest = exports.RebuildCorePackResponse = exports.RebuildCorePackRequest = exports.SyncCorePackResponse = exports.SyncCorePackRequest = exports.HashType = exports.ModelType = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const player_pb_js_1 = require("./player_pb.js");
const common_pb_js_1 = require("./common_pb.js");
/**
 * @generated from enum assets.ModelType
 */
var ModelType;
(function (ModelType) {
    /**
     * @generated from enum value: ANYWHERE = 0;
     */
    ModelType[ModelType["ANYWHERE"] = 0] = "ANYWHERE";
    /**
     * @generated from enum value: WALL = 1;
     */
    ModelType[ModelType["WALL"] = 1] = "WALL";
    /**
     * @generated from enum value: FLOOR = 2;
     */
    ModelType[ModelType["FLOOR"] = 2] = "FLOOR";
    /**
     * @generated from enum value: DRINKABLE = 3;
     */
    ModelType[ModelType["DRINKABLE"] = 3] = "DRINKABLE";
    /**
     * @generated from enum value: COSMETIC = 4;
     */
    ModelType[ModelType["COSMETIC"] = 4] = "COSMETIC";
    /**
     * @generated from enum value: MENU = 5;
     */
    ModelType[ModelType["MENU"] = 5] = "MENU";
})(ModelType = exports.ModelType || (exports.ModelType = {}));
// Retrieve enum metadata with: proto3.getEnumType(ModelType)
protobuf_1.proto3.util.setEnumType(ModelType, "assets.ModelType", [
    { no: 0, name: "ANYWHERE" },
    { no: 1, name: "WALL" },
    { no: 2, name: "FLOOR" },
    { no: 3, name: "DRINKABLE" },
    { no: 4, name: "COSMETIC" },
    { no: 5, name: "MENU" },
]);
/**
 * @generated from enum assets.HashType
 */
var HashType;
(function (HashType) {
    /**
     * @generated from enum value: SHA1 = 0;
     */
    HashType[HashType["SHA1"] = 0] = "SHA1";
    /**
     * @generated from enum value: MD5 = 1;
     */
    HashType[HashType["MD5"] = 1] = "MD5";
})(HashType = exports.HashType || (exports.HashType = {}));
// Retrieve enum metadata with: proto3.getEnumType(HashType)
protobuf_1.proto3.util.setEnumType(HashType, "assets.HashType", [
    { no: 0, name: "SHA1" },
    { no: 1, name: "MD5" },
]);
/**
 * @generated from message assets.SyncCorePackRequest
 */
class SyncCorePackRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * A zip of the git content repo: template/, content/<category>/<pack>/, furniture-catalog.yml.
         *
         * @generated from field: bytes bundle = 1;
         */
        this.bundle = new Uint8Array(0);
        /**
         * When true, build the pack in-memory and diff it against the currently-served
         * pack WITHOUT touching the DB, GridFS, or the published settings.
         *
         * @generated from field: bool dryRun = 2;
         */
        this.dryRun = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SyncCorePackRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncCorePackRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncCorePackRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SyncCorePackRequest, a, b);
    }
}
SyncCorePackRequest.runtime = protobuf_1.proto3;
SyncCorePackRequest.typeName = "assets.SyncCorePackRequest";
SyncCorePackRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "bundle", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "dryRun", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
exports.SyncCorePackRequest = SyncCorePackRequest;
/**
 * @generated from message assets.SyncCorePackResponse
 */
class SyncCorePackResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool success = 1;
         */
        this.success = false;
        /**
         * entries present in new but not current
         *
         * @generated from field: repeated string added = 6;
         */
        this.added = [];
        /**
         * entries present in current but not new
         *
         * @generated from field: repeated string removed = 7;
         */
        this.removed = [];
        /**
         * entries present in both but with different bytes
         *
         * @generated from field: repeated string changed = 8;
         */
        this.changed = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SyncCorePackResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncCorePackResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncCorePackResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SyncCorePackResponse, a, b);
    }
}
SyncCorePackResponse.runtime = protobuf_1.proto3;
SyncCorePackResponse.typeName = "assets.SyncCorePackResponse";
SyncCorePackResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "asset", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "hash", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "identical", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 6, name: "added", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "removed", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "changed", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "currentHash", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
exports.SyncCorePackResponse = SyncCorePackResponse;
/**
 * @generated from message assets.RebuildCorePackRequest
 */
class RebuildCorePackRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new RebuildCorePackRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RebuildCorePackRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RebuildCorePackRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(RebuildCorePackRequest, a, b);
    }
}
RebuildCorePackRequest.runtime = protobuf_1.proto3;
RebuildCorePackRequest.typeName = "assets.RebuildCorePackRequest";
RebuildCorePackRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
exports.RebuildCorePackRequest = RebuildCorePackRequest;
/**
 * @generated from message assets.RebuildCorePackResponse
 */
class RebuildCorePackResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string asset = 1;
         */
        this.asset = "";
        /**
         * @generated from field: string hash = 2;
         */
        this.hash = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new RebuildCorePackResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RebuildCorePackResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RebuildCorePackResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(RebuildCorePackResponse, a, b);
    }
}
RebuildCorePackResponse.runtime = protobuf_1.proto3;
RebuildCorePackResponse.typeName = "assets.RebuildCorePackResponse";
RebuildCorePackResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "asset", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
exports.RebuildCorePackResponse = RebuildCorePackResponse;
/**
 * @generated from message assets.ListAssetsRequest
 */
class ListAssetsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: map<string, string> metadata = 1;
         */
        this.metadata = {};
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ListAssetsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAssetsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAssetsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(ListAssetsRequest, a, b);
    }
}
ListAssetsRequest.runtime = protobuf_1.proto3;
ListAssetsRequest.typeName = "assets.ListAssetsRequest";
ListAssetsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "metadata", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
]);
exports.ListAssetsRequest = ListAssetsRequest;
/**
 * @generated from message assets.ListAssetsResponse
 */
class ListAssetsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated assets.AssetInformation assetInfo = 1;
         */
        this.assetInfo = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ListAssetsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAssetsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAssetsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(ListAssetsResponse, a, b);
    }
}
ListAssetsResponse.runtime = protobuf_1.proto3;
ListAssetsResponse.typeName = "assets.ListAssetsResponse";
ListAssetsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "assetInfo", kind: "message", T: AssetInformation, repeated: true },
]);
exports.ListAssetsResponse = ListAssetsResponse;
/**
 * @generated from message assets.GetHashRequest
 */
class GetHashRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string asset = 1;
         */
        this.asset = "";
        /**
         * @generated from field: assets.HashType hashType = 2;
         */
        this.hashType = HashType.SHA1;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetHashRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetHashRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetHashRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetHashRequest, a, b);
    }
}
GetHashRequest.runtime = protobuf_1.proto3;
GetHashRequest.typeName = "assets.GetHashRequest";
GetHashRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "asset", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "hashType", kind: "enum", T: protobuf_1.proto3.getEnumType(HashType) },
]);
exports.GetHashRequest = GetHashRequest;
/**
 * @generated from message assets.GetHashResponse
 */
class GetHashResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool success = 1;
         */
        this.success = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetHashResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetHashResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetHashResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetHashResponse, a, b);
    }
}
GetHashResponse.runtime = protobuf_1.proto3;
GetHashResponse.typeName = "assets.GetHashResponse";
GetHashResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "hash", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
exports.GetHashResponse = GetHashResponse;
/**
 * @generated from message assets.UploadAssetRequest
 */
class UploadAssetRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string filename = 1;
         */
        this.filename = "";
        /**
         * @generated from field: map<string, string> metadata = 2;
         */
        this.metadata = {};
        /**
         * @generated from field: bytes data = 3;
         */
        this.data = new Uint8Array(0);
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UploadAssetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UploadAssetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UploadAssetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(UploadAssetRequest, a, b);
    }
}
UploadAssetRequest.runtime = protobuf_1.proto3;
UploadAssetRequest.typeName = "assets.UploadAssetRequest";
UploadAssetRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
    { no: 3, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
]);
exports.UploadAssetRequest = UploadAssetRequest;
/**
 * @generated from message assets.UploadAssetResponse
 */
class UploadAssetResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool success = 1;
         */
        this.success = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UploadAssetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UploadAssetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UploadAssetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(UploadAssetResponse, a, b);
    }
}
UploadAssetResponse.runtime = protobuf_1.proto3;
UploadAssetResponse.typeName = "assets.UploadAssetResponse";
UploadAssetResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
exports.UploadAssetResponse = UploadAssetResponse;
/**
 * @generated from message assets.GetAssetRequest
 */
class GetAssetRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetAssetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAssetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAssetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetAssetRequest, a, b);
    }
}
GetAssetRequest.runtime = protobuf_1.proto3;
GetAssetRequest.typeName = "assets.GetAssetRequest";
GetAssetRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
exports.GetAssetRequest = GetAssetRequest;
/**
 * @generated from message assets.GetAssetResponse
 */
class GetAssetResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool success = 1;
         */
        this.success = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetAssetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAssetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAssetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetAssetResponse, a, b);
    }
}
GetAssetResponse.runtime = protobuf_1.proto3;
GetAssetResponse.typeName = "assets.GetAssetResponse";
GetAssetResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "asset", kind: "message", T: Asset, opt: true },
]);
exports.GetAssetResponse = GetAssetResponse;
/**
 * @generated from message assets.AssetInformation
 */
class AssetInformation extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: map<string, string> metadata = 2;
         */
        this.metadata = {};
        /**
         * @generated from field: string filename = 3;
         */
        this.filename = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AssetInformation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AssetInformation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AssetInformation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AssetInformation, a, b);
    }
}
AssetInformation.runtime = protobuf_1.proto3;
AssetInformation.typeName = "assets.AssetInformation";
AssetInformation.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
    { no: 3, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
exports.AssetInformation = AssetInformation;
/**
 * @generated from message assets.Asset
 */
class Asset extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bytes data = 2;
         */
        this.data = new Uint8Array(0);
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new Asset().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Asset().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Asset().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(Asset, a, b);
    }
}
Asset.runtime = protobuf_1.proto3;
Asset.typeName = "assets.Asset";
Asset.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "information", kind: "message", T: AssetInformation },
    { no: 2, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
]);
exports.Asset = Asset;
/**
 * @generated from message assets.ModelCategory
 */
class ModelCategory extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 id = 1;
         */
        this.id = 0;
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: repeated assets.ModelPack pack = 3;
         */
        this.pack = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ModelCategory().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModelCategory().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModelCategory().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(ModelCategory, a, b);
    }
}
ModelCategory.runtime = protobuf_1.proto3;
ModelCategory.typeName = "assets.ModelCategory";
ModelCategory.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "pack", kind: "message", T: ModelPack, repeated: true },
]);
exports.ModelCategory = ModelCategory;
/**
 * @generated from message assets.ModelPack
 */
class ModelPack extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 id = 1;
         */
        this.id = 0;
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: repeated assets.Model model = 4;
         */
        this.model = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ModelPack().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModelPack().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModelPack().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(ModelPack, a, b);
    }
}
ModelPack.runtime = protobuf_1.proto3;
ModelPack.typeName = "assets.ModelPack";
ModelPack.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "creator", kind: "message", T: player_pb_js_1.SimplePlayer },
    { no: 4, name: "model", kind: "message", T: Model, repeated: true },
]);
exports.ModelPack = ModelPack;
/**
 * @generated from message assets.Model
 */
class Model extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 id = 1;
         */
        this.id = 0;
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: assets.ModelType type = 3;
         */
        this.type = ModelType.ANYWHERE;
        /**
         * @generated from field: map<string, string> info = 4;
         */
        this.info = {};
        /**
         * @generated from field: string asset = 5;
         */
        this.asset = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new Model().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Model().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Model().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(Model, a, b);
    }
}
Model.runtime = protobuf_1.proto3;
Model.typeName = "assets.Model";
Model.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "enum", T: protobuf_1.proto3.getEnumType(ModelType) },
    { no: 4, name: "info", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
    { no: 5, name: "asset", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
exports.Model = Model;
/**
 * @generated from message assets.BuildPackRequest
 */
class BuildPackRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated int32 categoryId = 1;
         */
        this.categoryId = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new BuildPackRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BuildPackRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BuildPackRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(BuildPackRequest, a, b);
    }
}
BuildPackRequest.runtime = protobuf_1.proto3;
BuildPackRequest.typeName = "assets.BuildPackRequest";
BuildPackRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "categoryId", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
exports.BuildPackRequest = BuildPackRequest;
/**
 * @generated from message assets.BuildPackResponse
 */
class BuildPackResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool success = 1;
         */
        this.success = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new BuildPackResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BuildPackResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BuildPackResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(BuildPackResponse, a, b);
    }
}
BuildPackResponse.runtime = protobuf_1.proto3;
BuildPackResponse.typeName = "assets.BuildPackResponse";
BuildPackResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "asset", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
exports.BuildPackResponse = BuildPackResponse;
/**
 * @generated from message assets.CreateCategoryRequest
 */
class CreateCategoryRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string name = 1;
         */
        this.name = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CreateCategoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCategoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCategoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CreateCategoryRequest, a, b);
    }
}
CreateCategoryRequest.runtime = protobuf_1.proto3;
CreateCategoryRequest.typeName = "assets.CreateCategoryRequest";
CreateCategoryRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
exports.CreateCategoryRequest = CreateCategoryRequest;
/**
 * @generated from message assets.CreateCategoryResponse
 */
class CreateCategoryResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool success = 1;
         */
        this.success = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CreateCategoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCategoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCategoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CreateCategoryResponse, a, b);
    }
}
CreateCategoryResponse.runtime = protobuf_1.proto3;
CreateCategoryResponse.typeName = "assets.CreateCategoryResponse";
CreateCategoryResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "categoryId", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
exports.CreateCategoryResponse = CreateCategoryResponse;
/**
 * @generated from message assets.DeletePackRequest
 */
class DeletePackRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 packId = 1;
         */
        this.packId = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new DeletePackRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeletePackRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeletePackRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(DeletePackRequest, a, b);
    }
}
DeletePackRequest.runtime = protobuf_1.proto3;
DeletePackRequest.typeName = "assets.DeletePackRequest";
DeletePackRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "packId", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
exports.DeletePackRequest = DeletePackRequest;
/**
 * @generated from message assets.DeletePackResponse
 */
class DeletePackResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool success = 1;
         */
        this.success = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new DeletePackResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeletePackResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeletePackResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(DeletePackResponse, a, b);
    }
}
DeletePackResponse.runtime = protobuf_1.proto3;
DeletePackResponse.typeName = "assets.DeletePackResponse";
DeletePackResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
exports.DeletePackResponse = DeletePackResponse;
/**
 * @generated from message assets.GetCategoryRequest
 */
class GetCategoryRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 id = 1;
         */
        this.id = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetCategoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCategoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCategoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetCategoryRequest, a, b);
    }
}
GetCategoryRequest.runtime = protobuf_1.proto3;
GetCategoryRequest.typeName = "assets.GetCategoryRequest";
GetCategoryRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
exports.GetCategoryRequest = GetCategoryRequest;
/**
 * @generated from message assets.GetCategoryResponse
 */
class GetCategoryResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool success = 1;
         */
        this.success = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetCategoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCategoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCategoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetCategoryResponse, a, b);
    }
}
GetCategoryResponse.runtime = protobuf_1.proto3;
GetCategoryResponse.typeName = "assets.GetCategoryResponse";
GetCategoryResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "category", kind: "message", T: ModelCategory, opt: true },
]);
exports.GetCategoryResponse = GetCategoryResponse;
/**
 * @generated from message assets.UploadPackRequest
 */
class UploadPackRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bytes zip = 2;
         */
        this.zip = new Uint8Array(0);
        /**
         * @generated from field: map<string, assets.ModelConfig> config = 3;
         */
        this.config = {};
        /**
         * @generated from field: string packName = 4;
         */
        this.packName = "";
        /**
         * @generated from field: int32 categoryId = 5;
         */
        this.categoryId = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UploadPackRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UploadPackRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UploadPackRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(UploadPackRequest, a, b);
    }
}
UploadPackRequest.runtime = protobuf_1.proto3;
UploadPackRequest.typeName = "assets.UploadPackRequest";
UploadPackRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "identifier", kind: "message", T: common_pb_js_1.PlayerIdentifier },
    { no: 2, name: "zip", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "config", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "message", T: ModelConfig } },
    { no: 4, name: "packName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "categoryId", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
exports.UploadPackRequest = UploadPackRequest;
/**
 * @generated from message assets.ModelConfig
 */
class ModelConfig extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: assets.ModelType type = 1;
         */
        this.type = ModelType.ANYWHERE;
        /**
         * @generated from field: map<string, string> config = 2;
         */
        this.config = {};
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ModelConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModelConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModelConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(ModelConfig, a, b);
    }
}
ModelConfig.runtime = protobuf_1.proto3;
ModelConfig.typeName = "assets.ModelConfig";
ModelConfig.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: protobuf_1.proto3.getEnumType(ModelType) },
    { no: 2, name: "config", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
]);
exports.ModelConfig = ModelConfig;
/**
 * @generated from message assets.UploadPackResponse
 */
class UploadPackResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool success = 1;
         */
        this.success = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UploadPackResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UploadPackResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UploadPackResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(UploadPackResponse, a, b);
    }
}
UploadPackResponse.runtime = protobuf_1.proto3;
UploadPackResponse.typeName = "assets.UploadPackResponse";
UploadPackResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
exports.UploadPackResponse = UploadPackResponse;
/**
 * @generated from message assets.UploadedImage
 */
class UploadedImage extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 id = 1;
         */
        this.id = 0;
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: string creator = 3;
         */
        this.creator = "";
        /**
         * @generated from field: string asset = 4;
         */
        this.asset = "";
        /**
         * @generated from field: uint64 createdAt = 5;
         */
        this.createdAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UploadedImage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UploadedImage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UploadedImage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(UploadedImage, a, b);
    }
}
UploadedImage.runtime = protobuf_1.proto3;
UploadedImage.typeName = "assets.UploadedImage";
UploadedImage.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "creator", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "asset", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "createdAt", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
]);
exports.UploadedImage = UploadedImage;
/**
 * @generated from message assets.GetUploadedImagesRequest
 */
class GetUploadedImagesRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetUploadedImagesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetUploadedImagesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetUploadedImagesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetUploadedImagesRequest, a, b);
    }
}
GetUploadedImagesRequest.runtime = protobuf_1.proto3;
GetUploadedImagesRequest.typeName = "assets.GetUploadedImagesRequest";
GetUploadedImagesRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "creator", kind: "message", T: common_pb_js_1.PlayerIdentifier, opt: true },
]);
exports.GetUploadedImagesRequest = GetUploadedImagesRequest;
/**
 * @generated from message assets.GetUploadedImagesResponse
 */
class GetUploadedImagesResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated assets.UploadedImage image = 1;
         */
        this.image = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetUploadedImagesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetUploadedImagesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetUploadedImagesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetUploadedImagesResponse, a, b);
    }
}
GetUploadedImagesResponse.runtime = protobuf_1.proto3;
GetUploadedImagesResponse.typeName = "assets.GetUploadedImagesResponse";
GetUploadedImagesResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "image", kind: "message", T: UploadedImage, repeated: true },
]);
exports.GetUploadedImagesResponse = GetUploadedImagesResponse;
/**
 * @generated from message assets.UploadImageRequest
 */
class UploadImageRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: bytes data = 3;
         */
        this.data = new Uint8Array(0);
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UploadImageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UploadImageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UploadImageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(UploadImageRequest, a, b);
    }
}
UploadImageRequest.runtime = protobuf_1.proto3;
UploadImageRequest.typeName = "assets.UploadImageRequest";
UploadImageRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "creator", kind: "message", T: common_pb_js_1.PlayerIdentifier },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
]);
exports.UploadImageRequest = UploadImageRequest;
/**
 * @generated from message assets.UploadImageResponse
 */
class UploadImageResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool success = 1;
         */
        this.success = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UploadImageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UploadImageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UploadImageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(UploadImageResponse, a, b);
    }
}
UploadImageResponse.runtime = protobuf_1.proto3;
UploadImageResponse.typeName = "assets.UploadImageResponse";
UploadImageResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "image", kind: "message", T: UploadedImage, opt: true },
]);
exports.UploadImageResponse = UploadImageResponse;
/**
 * @generated from message assets.DeleteImageRequest
 */
class DeleteImageRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 id = 2;
         */
        this.id = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new DeleteImageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteImageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteImageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(DeleteImageRequest, a, b);
    }
}
DeleteImageRequest.runtime = protobuf_1.proto3;
DeleteImageRequest.typeName = "assets.DeleteImageRequest";
DeleteImageRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "requester", kind: "message", T: common_pb_js_1.PlayerIdentifier },
    { no: 2, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
exports.DeleteImageRequest = DeleteImageRequest;
/**
 * @generated from message assets.DeleteImageResponse
 */
class DeleteImageResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool success = 1;
         */
        this.success = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new DeleteImageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteImageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteImageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(DeleteImageResponse, a, b);
    }
}
DeleteImageResponse.runtime = protobuf_1.proto3;
DeleteImageResponse.typeName = "assets.DeleteImageResponse";
DeleteImageResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
exports.DeleteImageResponse = DeleteImageResponse;
